import { LoadingGif } from "../../assets/images";

export const Loading = () => 
    <div className="d-flex align-items-center"><img className="mr-1" src={LoadingGif} alt="..." height={24} width={24}/><span>Loading...</span></div>